import React, { useState, useEffect } from "react";
import Sub_header from './Sub_header'

import axios from "axios";


import exportValue from "../apiconfig";
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2'
import Left_panel from "./Left_panel";
// import '../../components/loader.css';


const Rate_calculator = () => {
    const [productList, setproductList] = useState([]);
    console.log("productList == " , productList)
    const[volstate , setVolstate] = React.useState(null)
   const[stateloading , setloadingstate] = useState({isloading:false})
   const[setvisible , setvisiblestate] = useState(false)
   const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
   const[parceltype,setparceltypeState] = React.useState({parcel:true})
   const[documenttype,setdocumenttypeState] = React.useState({document:false})
   const[state,setState] = React.useState({  parcel_type:"Parcel" , from_postal_code:"" ,to_postal_code:"" , mode:"Domestic" , weight:"" , length:"" , width:"" , height:"" , country_name:"" })
   const[paymentmode,setpaymentmode]= React.useState({mode:1})
   const [codvalue,setcodvalue] = React.useState({cod_amount:0 , err:{}})
   const[volume, setVolume] = React.useState()
   const toggleSidebar = () => {
       setIsSidebarOpen(!isSidebarOpen);
       const homeSection = document.querySelector('.home-section');
       if (homeSection) {
           homeSection.classList.toggle('sidebar-closed');
       }
   };
    const getProductList = (index=0) => {

        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
    setloadingstate({isloading:true})
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/search_zone`;
        let sendData = {from_postal_code:state.from_postal_code ,
          to_postal_code:state.to_postal_code, 
          weight:volume && state.weight!=""?parseFloat(volume)>parseFloat(state.weight)?volume:state.weight:0.00,
          length:state.length,
          height:state.height,
          width:state.width,
         //  sort_by:sort ,
           parcel_type:state.parcel_type ,
            mode:state.mode,
            payment_mode:paymentmode.mode==2?"cod":"prepaid",
            order_amount:codvalue.cod_amount,
            carrier_type:1,
           
             from_country_code:"IN" ,
            
             
               to_country_code:"IN" ,}
          
        if(state.from_postal_code!="" && state.to_postal_code!="" && state.mode!="" && state.parcel_type!="" && state.weight!="" && state.height!="" && state.width!="" && state.length!=""){
          if(paymentmode.mode==1 || paymentmode.mode==2 && codvalue.cod_amount!="" ){
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
            console.log("res ", res);
           if(res.data.status == "success"){
         setproductList(res.data.output)
         setloadingstate({isloading:false})
         setvisiblestate(true)
           }
           else{
          
            setloadingstate({isloading:false})
            setvisiblestate(true)
           }
        

        }).catch((e) => {
            Toast.fire({
                background: "#206bc4",
                type: 'unsuccess',
                title: "Something went wrong",
                color: "white"
            });


        });
    }
    else{
      Toast.fire({
        background:"#a61c09",
        type: 'unsuccess',
        title: "Please enter cod value",
        color:"white"
      });
setloadingstate({isloading:false})

    }
         } 
         else{
          const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000
            })
            Toast.fire({
              background:"#a61c09",
              type: 'Unsuccess',
              title: "Please Fill All the Fields",
              color:"white"
            });
            setloadingstate({isloading:false})

      }
        }

    const handleChange=(e)=>{
      console.log("namess",e.target.name)
      console.log("value",e.target.value)
      console.log("type",e.target.type)

     
      let names = e.target.name
      let value= e.target.value
     
      if(e.target.type=="text"){
      setState({...state,[e.target.name]:value})
      }
      else if(e.target.type =="select-one"){
        setState({...state,[e.target.name]:value})
      }
      else if(e.target.type=="radio"){
          if(e.target.checked==true){
            
               if(e.target.name=="document"){
                setparceltypeState({...parceltype,parcel:false})
                setdocumenttypeState({...documenttype,document:true})
                setState({...state,parcel_type:"Document"})
              }
              else{
                setparceltypeState({...parceltype,parcel:true})
                setdocumenttypeState({...documenttype,document:false})
                setState({...state,parcel_type:"Parcel"})
              }
          }
      }
      else if(e.target.type=="number"){
        setState({...state,[e.target.name]:value})
      }
      else if(e.target.type=="date"){
          setState({...state,[e.target.name]:value})
         
      }
  }

    const reset =()=>{
      setState({...state , parcel_type:"Parcel" , from_postal_code:"" ,to_postal_code:"" , mode:"Domestic", weight:"" , length:"" , width:"" , height:"" , country_name:""})
      setdocumenttypeState({...documenttype,document:false})
      setparceltypeState({...parceltype,parcel:true})
      setcodvalue({...codvalue,cod_amount:0 , err:{}})
    }
    const payment_mode =(e)=>{
      if(e.target.name=="prepaid"){
        setpaymentmode({mode:1})
      }
      else{
        setpaymentmode({mode:2})
      }
    }
    const codvalueChange=(e)=>{
    
      setcodvalue({...codvalue,cod_amount:e.target.value , err:{}})
    }
  
    
    React.useEffect(() => {
      if ( state.height !== "" && state.width !== "" && state.length !== "") {
          let divisor = 5000 
          const calculatedVolume = ( state.height * state.width * state.length) / divisor;
          setVolume(calculatedVolume.toFixed(2));
      } else {
          setVolume(0);
      }
  }, [ state.height, state.width, state.length, volstate]);
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?>  */}
           
       <Sub_header/>

      <div className=''>
      <div class="col-12 col-md-2 mt-2">
                <h5>Rate Calculator</h5>
            </div>
    
            <div class="col-12 col-md-8">
                    <div class="card border-0 order_box shadow-sm">
                        <div class="card-body">
                            <section class="pb-5">
                                <div class="row">
                                    <div class="col-12 col-md-12 mb-3">
                                        <label for="" class="form-label">Shipment Type:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio"  onChange={(e)=>handleChange(e)} name="document" id="inlxineRadio1"  checked={documenttype.document==true && parceltype.parcel==false}/>
                                              <label class="form-check-label" for="inlineRadio1">Document</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="parcel" onChange={(e)=>handleChange(e)} id="inlixneRadio2" value={state.parcel_type} checked={parceltype.parcel==true && documenttype.document==false }/>
                                              <label class="form-check-label" for="inlineRadio2">Parcel</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Pickup Pincode:</label>
                                        <input type="text" class="form-control" id="" placeholder="Enter pickup pincode" name="from_postal_code" value={state.from_postal_code} onChange={(e)=>handleChange(e)}/>
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Delivery Pincode:</label>
                                        <input type="text" class="form-control" id="" placeholder="Enter delivery pincode" name="to_postal_code" value={state.to_postal_code} onChange={(e)=>handleChange(e)} />
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Actual Weight:</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="Enter Weight"  name="weight"  onChange={(e)=>handleChange(e)} value={state.weight}/>
                                            <span class="input-group-text">KG</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Dimensions:</label>
                                        <div class="row">
                                            <div class="col-12 col-md-4 mb-3">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" placeholder="H" onChange={(e)=>handleChange(e)} name="height" value={state.height}/>
                                                    <span class="input-group-text">CM</span>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 mb-3">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" placeholder="W" onChange={(e)=>handleChange(e)} name="width"  value={state.width}/>
                                                    <span class="input-group-text">CM</span>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 mb-3">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" placeholder="L" onChange={(e)=>handleChange(e)} name="length" value={state.length}/>
                                                    <span class="input-group-text">CM</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Mode:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="cod" id="inlineRadio2" value="option2" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==2} />
                                              <label class="form-check-label" for="inlineRadio1">Cash On Delivery</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==1}  />
                                              <label class="form-check-label" for="inlineRadio2">Prepaid</label>
                                            </div>
                                        </div>
                                    </div>
                                    {paymentmode.mode==2?
                        <div class="row">
                          <div class="col-12 col-md-5 mb-3">
                            <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount" 
                            onChange={(e)=>codvalueChange(e)} value={codvalue.cod_amount} />
                          </div>
                      </div>:""}
                                    {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipment Value (₹):</label>
                                        <div class="input-group">
                                            <span class="input-group-text">₹</span>
                                            <input type="text" class="form-control" placeholder="Enter the shipment values" value="0.00" />
                                        </div>
                                    </div> */}
                                    {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipping Dangerous Goods?:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                              <label class="form-check-label" for="inlineRadio1">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                              <label class="form-check-label" for="inlineRadio2">No</label>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>
                      
                        <h6 class="mb-3 mt-3">Applicable Weight  <span className='ms-5'>{volume && state.weight !== "" ? 
      (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + " Kg" :
      "0.00 Kg"
    }</span> </h6>
                                <div>
                                    <a onClick={()=>getProductList()} class="btn btn-primary me-2">Calculate</a>
                                    <a onClick={()=>reset()} class="btn btn-outline-primary">Reset</a>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
        
        
{stateloading.isloading==true?
    <div style={{ backgroundColor: "#f1f5f9", zIndex: 2, height: "100%", width: "100%", position: "absolute", opacity: "0.4" }}>
                    <div style={{ left: "30%", top: "25%", position: "absolute" }}>
                        <ReactLoading type={"spin"} color={"#000000"} height={300} width={89} />
                    </div>
                </div>:

setvisible==true?
        <div class="card border-0 shadow mt-4 ">
          <div class="card-body">
            <section>
            <table class="table table-bordered">
                    <thead class="">
                      <tr>
                        <th >Carrier</th>
                        <th >Product</th>
                        <th >Zone Name</th> 
                        {/* <th>Service</th> */}
                        <th >Charges</th>
                        <th >Carrier Commission</th>
                     
                     
                      </tr>
                    </thead>
                   
                    <tbody >
                      {productList.map((sub,index)=>(
                      <tr className="mt-4">
                       <td>
                        {/* <img src={`https://cdn.shiprath.com/images/${sub.carrierImage}`} width="100px" /> */}
                       {sub.service_name} </td>
                        <td>{sub.service_provider}</td>
                        <td>{sub.zone_name}</td>
                        {/* <td>{sub.product_type_name}</td> */}
                        <td>{sub.total_charges}</td>
                        <td>
                            {sub.commission_charge}
                        </td>
                        
                      </tr>
                         ))} 
                    </tbody>

                   
                </table>
            </section>
            </div>
            </div>

      
    
                   :""   }
                   </div>
     </section>
    </div>
  )
}

export default Rate_calculator
